import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import { Flex } from 'antd';
import { COMPLIANCE_COLORS } from '../shared/utils.index';

export const getComplianceStyle = (concreteClass, concreteBatches, token) => {
  const isQuality = concreteClass?.concrete_quality === true;
  const compliance = concreteBatches?.[0]?.compliance;
  const compliance90 = concreteBatches?.[0]?.compliance90;

  if (isQuality) {
    if (compliance === false && compliance90 === 0) {
      return {
        content: {
          backgroundColor: token.colorErrorBg,
          color: token.colorError,
        },
      };
    }
    if (compliance === true || compliance90 === 1) {
      return {
        content: {
          backgroundColor: token.colorSuccessBg,
          color: token.colorSuccess,
        },
      };
    }
    // Si ambos son null, fondo amarillo (no evaluado)
    if (
      (compliance === null || compliance === undefined) &&
      (compliance90 === null || compliance90 === undefined)
    ) {
      return {
        content: {
          backgroundColor: COMPLIANCE_COLORS.WARNING,
          color: 'black',
        },
      };
    }
  } else {
    if (compliance === true) {
      return {
        content: {
          backgroundColor: token.colorSuccessBg,
          color: token.colorSuccess,
        },
      };
    }
    if (compliance === false) {
      return {
        content: {
          backgroundColor: token.colorErrorBg,
          color: token.colorError,
        },
      };
    }
    // Si es null, fondo amarillo (no evaluado)
    if (compliance === null || compliance === undefined) {
      return {
        content: {
          backgroundColor: COMPLIANCE_COLORS.WARNING,
          color: 'black',
        },
      };
    }
  }
  return {};
};

export const renderComplianceIcons = (
  concreteClass = {},
  concreteBatches = [],
  token,
  intl,
) => {
  const isQuality = concreteClass?.concrete_quality === true;
  const compliance = concreteBatches?.[0]?.compliance;
  const compliance90 = concreteBatches?.[0]?.compliance90;

  const getIcon = (value) => {
    if (value === true || value === 1)
      return <CheckCircleFilled style={{ color: token.colorSuccess }} />;

    if (value === false || value === 0)
      return <CloseCircleFilled style={{ color: token.colorError }} />;

    return (
      <span style={{ color: 'rgb(102, 102, 102)' }}>
        {intl
          .formatMessage({
            id: 'pages.quality.normative.statistical-control.batchDetail.notEvaluated',
            defaultMessage: 'NO EVALUADO',
          })
          .toLocaleUpperCase()}
      </span>
    );
  };

  if (isQuality) {
    return (
      <Flex gap="8px" align="center">
        {getIcon(compliance)}
        <span>/</span>
        {getIcon(compliance90)}
      </Flex>
    );
  }

  return getIcon(compliance);
};
